import { connect } from 'react-redux'
import ServiceWorkingHours from '../../components/services/edit/working-hours/ServiceWorkingHours'
import { actionCreators } from '../../state/actions/services/index'
import { IStoreState } from '../../types/index'
import { getService } from '../../state/reducers/services/index'

const digitsInRandomNumber = 10000

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  const serviceId = state.service.metadata.edit.serviceId
  const service = serviceId && getService(state, serviceId)
  console.log(state.serviceEdit.workingHoursSection.list)
  return {
    serviceId,
    orgId: state.organizations.currentOrgId,
    workingHoursList: state.serviceEdit.workingHoursSection.list,
    isAllDaysActive: service ? service.isAllDaysActive : true
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onAddClick: () => {
      return dispatch(actionCreators.workingHoursAddItem(createEmptyWorkingHours()))
    },
    onAllDaysActiveChange: (id: string, isAllDaysActive: boolean) => {
      dispatch(actionCreators.workingHoursSetAllDaysActive(!isAllDaysActive, id))
    }
  }
}

const createEmptyWorkingHours = () => {
  return {
    id: `new-${Math.floor(Math.random() * digitsInRandomNumber)}`,
    from: '',
    until: '',
    days: []
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceWorkingHours)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceWorkingHours.ts